var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _c("div", { staticStyle: { "line-height": "49px", height: "49px" } }, [
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small mr15",
            staticStyle: { float: "right", "margin-top": "8px" },
            on: {
              click: function($event) {
                _vm.saveRoleRegion()
              }
            }
          },
          [_c("span", [_vm._v("保存")])]
        )
      ]),
      _vm._v(" "),
      _c("swb-region-select", {
        ref: "swb_region_select",
        attrs: { regionList: _vm.regionList, isShowDiv: false }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cbd398d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cbd398d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/authx/ComRoleRegion.vue
// module id = 2204
// module chunks = 1